<template>
  <div class="relative">
    <div class="relative">
      <input
        class="
         py10 w-100 border-box brdr-none brdr-bottom-1
         brdr-cl-primary sans-serif
       "
        :class="[{pr30: type === 'password', empty: value === '', '-high-placeholder': type==='date' || highPlaceholder}, fontSize]"
        :type="type === 'password' ? passType : type"
        :name="name"
        :autocomplete="autocomplete"
        :value="value"
        :autofocus="autofocus"
        :ref="name"
        :readonly="readonly"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur')"
        @keyup.enter="$emit('keyup.enter', $event.target.value)"
        @keyup="$emit('keyup', $event)"
      >
      <label>{{ placeholder }}</label>
    </div>
    <button
      v-if="iconActive"
      type="button"
      class="
        icon material-icons absolute brdr-none no-outline
        p0 bg-cl-transparent cl-brdr-secondary pointer
      "
      @click="togglePassType()"
      :aria-label="'Toggle password visibility'"
      :title="'Toggle password visibility'"
    >
      {{ icon }}
    </button>
    <template v-if="validation">
      <span class="block cl-error h6 mt8" v-if="validation.condition">
        {{ validation.text }}
      </span>
    </template>
    <template v-else-if="validations">
      <span
        v-for="(rule, index) in validations"
        :key="index"
        v-if="rule.condition"
        class="block cl-error h6 mt8"
        data-testid="errorMessage"
      >
        {{ rule.text }}
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  data () {
    return {
      passType: 'password',
      iconActive: false,
      icon: 'visibility'
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    fontSize: {
      type: String,
      required: false,
      default: 'h4'
    },
    focus: {
      type: Boolean,
      required: false,
      default: false
    },
    highPlaceholder: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    validation: {
      type: Object,
      required: false,
      default: () => { }
    },
    validations: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    togglePassType () {
      if (this.passType === 'password') {
        this.passType = 'text'
        this.icon = 'visibility_off'
      } else {
        this.passType = 'password'
        this.icon = 'visibility'
      }
    },
    // setFocus sets focus on a field which has a value of 'ref' tag equal to fieldName
    setFocus (fieldName) {
      if (this.name === fieldName) {
        this.$refs[this.name].focus()
      }
    }
  },
  created () {
    if (this.type === 'password') {
      this.iconActive = true
    }
  },
  mounted () {
    if (this.focus) {
      this.$refs[this.name].focus()
    }
  }
}
</script>

<style lang="scss" scoped>
  $color-tertiary: color(tertiary);
  $color-black: color(black);
  $color-puerto-rico: color(black);
  $color-hover: color(tertiary, $colors-background);

  input {
    background: inherit;
    &.empty[type="date"]::-webkit-datetime-edit-year-field,
    &.empty[type="date"]::-webkit-datetime-edit-month-field,
    &.empty[type="date"]::-webkit-datetime-edit-day-field {
      color: $color-tertiary;
    }

    &.empty[type="date"]::-webkit-datetime-edit {
      color: $color-tertiary;
    }

    &:hover,
    &:focus {
      outline: none;
      border-color: $color-puerto-rico;
    }

    &:disabled,
    &:disabled + label {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  label {
    color:#999;
    position:absolute;
    pointer-events:none;
    user-select: none;
    font-weight: 300;
    left: 0;
    top: 10px;
    transition:0.2s ease all;
    -moz-transition:0.2s ease all;
    -webkit-transition:0.2s ease all;
  }
  input:focus ~ label, input:not(.empty) ~ label, input.-high-placeholder ~ label{
    top: -10px;
    font-size:16px;
    color:$color-puerto-rico;
  }

  .icon {
    right: 6px;
    top: 10px;
    &:hover,
    &:focus {
      color: $color-hover;
    }
  }
</style>
